import { render, staticRenderFns } from "./CampaignsOfRequestContact.vue?vue&type=template&id=2a5ed1d4&scoped=true"
import script from "./CampaignsOfRequestContact.vue?vue&type=script&lang=js"
export * from "./CampaignsOfRequestContact.vue?vue&type=script&lang=js"
import style0 from "./CampaignsOfRequestContact.vue?vue&type=style&index=0&id=2a5ed1d4&prod&scoped=true&lang=css"
import style1 from "./CampaignsOfRequestContact.vue?vue&type=style&index=1&id=2a5ed1d4&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5ed1d4",
  null
  
)

export default component.exports